import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import ForYouVideoForm from "../components/ForYouVideoForm";

const ForYouVideoDetailView = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const location = useLocation();
  const { video } = location.state || {};

  const [updatedVideo] = useState(video);
  const { id } = useParams();
  const navigate = useNavigate();

  if (!video) {
    return <div>No Video data available</div>;
  }

  const handleEditToggle = () => {
    setIsEditing(true);
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/for-you-category/delete-foryou-video/${id}`
      );

      if (response.data.success) {
        toast.success(response.data.message || "Video deleted successfully");
        setTimeout(() => navigate("/for-you-video"), 2000);
      } else {
        toast.error(response.data.message || "Failed to delete the video");
      }
    } catch (error) {
      console.error("Error during delete:", error);
      toast.error(
        error.response?.data?.message || "Failed to delete the video"
      );
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  return (
    <>
      {!isEditing ? (
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={styles.container}>
            <div style={styles.header}>
              <h2 style={styles.title}>Video Profile</h2>
              <div style={styles.buttonContainer}>
                <button onClick={handleDeleteClick} style={styles.deleteButton}>
                  Delete
                </button>
                <button onClick={handleEditToggle} style={styles.editButton}>
                  Edit
                </button>
              </div>
            </div>

            <div style={styles.infoContainer}>
              <div style={styles.infoRow}>
                <span style={styles.span}>Video ID</span>
                <span style={styles.span}>{video.id}</span>
              </div>

              <div style={styles.infoRow}>
                <span style={styles.span}>Title</span>
                <span style={styles.span}>{video.title}</span>
              </div>
              
              <div style={styles.infoRow}>
                <span style={styles.span}>Thumbnail</span>
                {video.thumbnail ? (
                  <img
                    src={video.thumbnail}
                    alt="Thumbnail"
                    style={{ width: "100%", maxWidth: "200px" }}
                    onError={(e) => {
                      console.error("Image failed to load:", video.thumbnail); // Debugging log
                      e.target.src = "/placeholder-image.png"; // Fallback image
                    }}
                  />
                ) : (
                  <span>No thumbnail available</span>
                )}
              </div>

              <div style={styles.infoRow}>
                <span style={styles.span}>Video</span>
                <video
                  controls
                  style={{ width: "100%", maxWidth: "400px" }}
                  src={video.video}
                />
              </div>
              <div style={styles.infoRow}>
                <span style={styles.span}>Categories</span>
                <span style={styles.span}>
                  {video.categories?.join(", ") || "No categories"}
                </span>
              </div>
            </div>

            {showDeleteModal && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContainer}>
                  <p style={styles.modalText}>
                    Are you sure you want to delete this video?
                  </p>
                  <button
                    style={styles.confirmButton}
                    onClick={handleConfirmDelete}
                    disabled={isDeleting}
                  >
                    {isDeleting ? "Deleting..." : "Yes, delete"}
                  </button>
                  <button
                    style={styles.cancelButton}
                    onClick={handleCloseDeleteModal}
                    disabled={isDeleting}
                  >
                    No, keep it
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <ForYouVideoForm user={updatedVideo} />
      )}
    </>
  );
};

const styles = {
  container: {
    backgroundColor: "#fff",
    border: "0px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "Poppins",
    overflow: "hidden",
    width: "600px",
    position: "relative",
    marginBottom: "5%"
  },
  header: {
    alignItems: "center",
    backgroundColor: "#064260",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 35px",
  },
  title: {
    fontSize: "21px",
    fontWeight: 600,
    margin: 0,
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
  },
  editButton: {
    backgroundColor: "#27B99A",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  deleteButton : {
    backgroundColor: "#ED3A3A",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  infoContainer: {
    border: "0",
    padding: "0",
  },
  infoRow: {
    borderBottom: "1px solid #eee",
    display: "flex",
    fontSize: "1em",
    justifyContent: "space-between",
    padding: "20px 35px",
    gap: "20px",
  },
  span: {
    fontSize: "17px",
    fontWeight: 600,
    margin: 0,
  },
  modalOverlay: {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
  },
  modalContainer: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "396px",
    padding: "35px 46px 55px 46px",
    textAlign: "center",
  },
  modalText: {
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "1.5",
    wordWrap: "break-word",
  },
  confirmButton: {
    border: "none",
    color: "#064260",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  },
  cancelButton: {
    border: "none",
    color: "#064260",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  }
};

export default ForYouVideoDetailView;